<template>
  <div class="page-careers-uk">
    <div v-if="bannerImgUrl" class="careers-banner">
      <img v-lazy-load :data-src="bannerImgUrl">
    </div>
    <div class="careers-contenter">
      <div class="loading">
        <Loading :show="false" />
      </div>
      <div id="grnhse_app" class="careers-wrapper" />
    </div>
  </div>
</template>
<script>
import Loading from 'components/common/Loading/index.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      bannerImgUrl: '',
    }
  },
  mounted() {
    // 载入Grnhse页面
    if (window.Grnhse) {
      window.Grnhse.Iframe.load();
    }
  },
}
</script>
<style lang="scss" scoped>
.page-careers-uk {
  background: #fff;

  .careers-banner {
    width: 1240px;
    margin: 20px auto 0 auto;

    img {
      display: block;
      width: 100%;
    }
  }

  .careers-contenter {
    position: relative;
    min-height: 600px;

    .loading {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -30px;
      z-index: 1;
    }

    .careers-wrapper {
      position: relative;
      z-index: 10;
    }
  }
}
</style>
